import TeaserSlider from '../teaser-slider/TeaserSlider';


const mql = window.matchMedia('(min-width: 830px)');

class TopicGrid extends TeaserSlider {
  constructor($topicGrid, mq) {
    super($topicGrid, mq, {
      inner: '.topic-grid__inner',
      teasersContainer: '.topic-grid__teasers',
      teaserWrappers: '.topic-grid__teaser',
    });
  }
}

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];
  const isDesktop = mq.matches;
  const $topicGrids = document.querySelectorAll('.topic-grid');

  if ($topicGrids && !isDesktop) {
    $topicGrids.forEach(($slider) => {
      componentStore.push(new TopicGrid($slider, mq));
    });
  } else {
    componentStore.forEach(component => component.deconstructor && component.deconstructor());
  }
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
